import api from "@/api/asset_rental";
import { errorHandler } from "../exports/error_management";

import { StorageCache } from "../exports/dataStorage";

const storageKey = "ams-order-asset-rentalkey";
const prefixKey = "ams-order-asset-rentalkey";

const getSuffixKey = (obj) => `-${btoa(JSON.stringify(obj))}`;

const state = {
  item: null,
  items: [],
  transaction_items: [],
  activity: [],
  customer: [],
  bankcode: [],
  filters: {},
  pagination: null,
  transaction_items_pagination: null,
  query: "",
};

const getters = {
  customer(state) {
    return state.item || null;
  },
};

const mutations = {
  set_item(state, payload) {
    state.item = payload;
  },
  set_items(state, payload) {
    state.items = payload;
  },
  set_transaction_items(state, payload) {
    state.transaction_items = payload;
  },

  SET_PAGINATION(state, pag) {
    state.pagination = pag;
  },
  SET_PAGINATION_TRANSACTION_ITEMS(state, pag) {
    state.transaction_items_pagination = pag;
  },
  SET_ORDERS(state, orders) {
    state.activity = orders;
  },
  SET_Customer(state, customers) {
    state.customer = customers;
  },

  SET_Bank(state, bank) {
    state.bankcode = bank;
  },

  SET_FILTERS(state, filters) {
    state.filters = filters;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
};

const actions = {
  async create(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.create(payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },
  async fetchById(context, id) {
    try {
      id = parseInt(id);
      if (!id) {
        context.commit("set_item", null);
        return;
      }
      const {
        data: {
          success: { data },
        },
      } = await api.fetchById(id);

      console.log("fetch item", data);
      context.commit("set_item", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchAll(
    { commit },
    { query, filters, page: page_no, isforcedReload }
  ) {
    try {

     
      filters = filters || {};
      query = query || "";

      commit("SET_FILTERS", filters);
      commit("SET_QUERY", query);

      const obj = {
        page: page_no,
        filters,
        query,
      };

      isforcedReload = true;

      const suffixKey = getSuffixKey(obj);
      const storageCache = new StorageCache(prefixKey, suffixKey);
      let value;
      let is_valid = false;

      if (isforcedReload) {
        is_valid = false;
      } else {
        const { is_valid: _is_valid, value: _value } = storageCache.getObject();
        is_valid = _is_valid;
        value = _value;
      }

      if (!is_valid) {
        page_no = parseInt(page_no) || 1;
        const result = await api.fetchAll(query, filters, page_no);
        const data = result.data.success.data;
        storageCache.set(data);
        value = data;
      }

      const {
        data: _orders = [],
        current_page: page = 1,
        per_page: pageSize = 15,
        total = 0,
      } = value || {};
      commit("SET_PAGINATION", {
        page,
        pageSize,
        total,
      });
      commit("set_items", _orders);
    } catch (err) {
      errorHandler(err);
    }
  },

  async customerFetchAll(context) {
    try {
      const {
        data: {
          success: { data },
        },
      } = await api.fetchAll();
      context.commit("set_items", data);
    } catch (err) {
      errorHandler(err);
    }
  },

  async update(context, payload) {
    const storageCache = new StorageCache(storageKey);
    try {
      console.log("update", payload);
      storageCache.reset();
      await api.update(payload.id, payload);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },

  async delete(context, id) {
    const storageCache = new StorageCache(storageKey);
    try {
      storageCache.reset();
      await api.delete(id);
      // context.dispatch("fetchAll");
    } catch (err) {
      errorHandler(err);
    }
  },

  async fetchOrders({ commit }) {
    try {
      const response = await api.fetchorder(); // Adjust the API endpoint accordingly
      commit("SET_ORDERS", response.data.success.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },

  async fetchCustomer({ commit }) {
    try {
      const response = await api.fetchcustomer(); // Adjust the API endpoint accordingly
      commit("SET_Customer", response.data.success.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },

  async fetchBank({ commit }) {
    try {
      const response = await api.fetchBank(); // Adjust the API endpoint accordingly

      commit("SET_Bank", response.data.success.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  },

  async fetchActivityTransactions(
    { commit },
    { query, filters, page: page_no, isforcedReload }
  ) {
    try {
      filters = filters || {};
      query = query || "";

      commit("SET_FILTERS", filters);
      commit("SET_QUERY", query);

      const obj = {
        page: page_no,
        filters,
        query,
      };

      isforcedReload = !!isforcedReload;
      const prefixKey = "ams-activity-transactions-key";
      const suffixKey = getSuffixKey(obj);
      const storageCache = new StorageCache(prefixKey, suffixKey);
      let value;
      let is_valid = false;

      if (isforcedReload) {
        is_valid = false;
      } else {
        const { is_valid: _is_valid, value: _value } = storageCache.getObject();
        is_valid = _is_valid;
        value = _value;
      }

      if (!is_valid) {
        page_no = parseInt(page_no) || 1;
        const result = await api.fetchActivityTransactions(
          query,
          filters,
          page_no
        );
        const data = result.data.success.data;
        storageCache.set(data);
        value = data;
      }

      const {
        data: _orders = [],
        current_page: page = 1,
        per_page: pageSize = 10,
        total = 0,
      } = value || {};
      commit("SET_PAGINATION_TRANSACTION_ITEMS", {
        page,
        pageSize,
        total,
      });
      commit("set_transaction_items", _orders);
    } catch (err) {
      errorHandler(err);
    }
  },

  async exportExcel(context, { query, filters }) {
    try {
      filters = filters || {};
      query = query || "";

      const response = await api.exportExcel(query, filters, true);
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AssetRental.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },
  async exportPDF(context, { query, filters ,export_option}) {
    try {
      filters = filters || {};
      query = query || "";
  
      const response = await api.exportPDF(query, filters, true,export_option);
      var blob;
      if(export_option == 'pdf'){
         blob = new Blob([response.data], {
          type: "application/pdf", // Set the MIME type to 'application/pdf' for PDF files
        });
      }else{
         blob = new Blob([response.data], {
          type: "application/vnd.ms-word", // Set the MIME type to 'application/pdf' for PDF files
        });
      }
     
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      if(export_option == 'pdf'){
      link.setAttribute("download", "AssetRental.pdf"); // Set the filename with the appropriate extension
      }else{
      link.setAttribute("download", "AssetRental.doc");
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },
  

  async exportExcelOrderTransaction(_, { query, filters }) {
    try {
      filters = filters || {};
      query = query || "";

      const response = await api.exportExcelOrderTransaction(
        query,
        filters,
        true
      );
      const blob = new Blob([response.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ActivityTransactions.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error fetching request:", err);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
